import { IMentionsState } from 'common/types/mentions.types';

export const createMentionsState = (textfieldId) => {
  const initialCommentState: IMentionsState = {
    textfieldId,
    mentionedCounter: 0,
    textfieldValue: '',
    textfieldCharacterLength: 0,
    isMentioning: false,
    isTagging: false,
    hashCount: -1,
    autoTag: false,
    selectedTarget: '',
    triggerIndex: -1,
    addHashButtonTriggered: false,
  }

  return initialCommentState
}
